import {
  Card,
  CardContent,
  Typography,
  Stack,
  Grid,
  Chip,
  Box,
  LinearProgress,
} from "@mui/material";
import { SEMANTIC } from "./theme/brand";

function getEstado(cliente) {
  if (!cliente.fechaLimite) return "ok";
  const hoy = new Date().toISOString().slice(0, 10);
  const en3 = new Date(Date.now() + 3 * 86400000).toISOString().slice(0, 10);
  if (cliente.fechaLimite < hoy) return "vencido";
  if (cliente.fechaLimite <= en3) return "proximo";
  return "ok";
}

export default function DashboardCreditos({ store, onGoCreditos }) {
  const clientes = store.clientesConDeuda;
  if (clientes.length === 0) return null;

  const moneda = store.config.moneda;
  const totalDeuda = store.deudaTotal;
  const vencidos = clientes.filter(c => getEstado(c) === "vencido");
  const deudaVencida = vencidos.reduce((s, c) => s + c.saldoPendiente, 0);
  const proximos = clientes.filter(c => getEstado(c) === "proximo");
  const enRiesgo = deudaVencida + proximos.reduce((s, c) => s + c.saldoPendiente, 0);

  return (
    <Card variant="outlined" sx={{ mt: 3, borderTop: 3, borderTopColor: vencidos.length > 0 ? "error.main" : "warning.main" }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="subtitle1">Dinero por cobrar</Typography>
          {onGoCreditos && (
            <Chip label="Ver créditos" size="small" onClick={onGoCreditos} clickable color="primary" variant="outlined" />
          )}
        </Stack>

        <Grid container spacing={1.5} mb={2}>
          <Grid item xs={4}>
            <Box textAlign="center">
              <Typography variant="h6" component="p" fontWeight={800} color="text.primary">
                {moneda} {totalDeuda.toLocaleString()}
              </Typography>
              <Typography variant="caption" color="text.secondary">Total por cobrar</Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box textAlign="center">
              <Typography variant="h6" component="p" fontWeight={800} color="error.main">
                {moneda} {deudaVencida.toLocaleString()}
              </Typography>
              <Typography variant="caption" color="text.secondary">Vencido</Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box textAlign="center">
              <Typography variant="h6" component="p" fontWeight={800} color="warning.main">
                {moneda} {enRiesgo.toLocaleString()}
              </Typography>
              <Typography variant="caption" color="text.secondary">Vencido o por vencer</Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Top 5 deudores */}
        <Typography variant="caption" fontWeight={700} color="text.secondary" mb={1} display="block">
          Clientes con deuda más alta
        </Typography>
        <Stack spacing={0.75}>
          {[...clientes].sort((a, b) => b.saldoPendiente - a.saldoPendiente).slice(0, 5).map(c => {
            const estado = getEstado(c);
            const pct = c.totalDeuda > 0 ? (c.totalPagado / c.totalDeuda) * 100 : 0;
            return (
              <Box key={c.key} sx={{ px: 1.5, py: 0.75, borderRadius: 1.5, bgcolor: estado === "vencido" ? SEMANTIC.dangerTint : "background.default" }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.25}>
                  <Stack direction="row" spacing={0.75} alignItems="center">
                    <Typography variant="body2" fontWeight={600}>{c.nombre}</Typography>
                    {estado === "vencido" && <Chip label="Vencido" size="small" color="error" sx={{ height: 18, fontSize: 9, fontWeight: 700 }} />}
                    {estado === "proximo" && <Chip label="Por vencer" size="small" color="warning" sx={{ height: 18, fontSize: 9, fontWeight: 700 }} />}
                  </Stack>
                  <Typography variant="body2" fontWeight={700} color={estado === "vencido" ? "error.main" : "text.primary"}>
                    {moneda} {c.saldoPendiente.toLocaleString()}
                  </Typography>
                </Stack>
                <LinearProgress
                  variant="determinate"
                  value={Math.min(100, pct)}
                  color={estado === "vencido" ? "error" : estado === "proximo" ? "warning" : "success"}
                  sx={{ height: 3, borderRadius: 2 }}
                />
              </Box>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
}
